module.exports = function() {
  return new Worker(__webpack_public_path__ + "6296ed179d50d446d388.worker.js");
};